export default __webpack_public_path__ + "static/home-background-xl-c9a01f2edbb55dde9d95e5b0e9ebc014.jpg";